angular.module('zc.projects')

.directive 'zcThumbnailSelectorConfirm', ($filter, BaseProjectConfirm) ->
  confirm = new BaseProjectConfirm $filter('translate')('projectsSettings.other.thumbnailSelectorConfirm.thumbnailImage'), ['thumbnail_url']
  confirm.createDirective confirm.requestRecentHistories



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/other/thumbnail_selector_confirm.directive.coffee